/**
 * Environment utilities for Vite
 *
 * Use these helpers instead of accessing process.env or import.meta.env directly.
 * This provides a consistent API and makes testing easier.
 */

/**
 * Get the public URL (base path for assets)
 */
export const PUBLIC_URL = (import.meta.env.BASE_URL ?? '').replace(/\/$/, '');

/**
 * True when running in development mode (local dev server)
 */
export const isDev = import.meta.env.DEV;

/**
 * True when running in production mode (built app)
 * Uncomment this code if we ever need to explicitly check for production mode
 */
// export const isProd = import.meta.env.PROD;

/**
 * Get environment variable by name (expects VITE_ prefix in .env files)
 * Example: getEnvVar('ENVIRONMENT') reads VITE_ENVIRONMENT
 */
export function getEnvVar(name: string): string | undefined {
  const viteKey = `VITE_${name}`;
  return (
    (import.meta.env as Record<string, string>)[viteKey] ??
    (import.meta.env as Record<string, string>)[name]
  );
}
